import { api } from "@/lib/api"

export function useIsOrgAdmin(): {
    isOrgAdmin: boolean
    isLoading: boolean
    isError: boolean
    refetch: () => Promise<unknown>
} {
    const { data, isLoading, isError, refetch } =
        api.user.getMyOrgAdminStatus.useQuery()
    return {
        isOrgAdmin: data?.isOrgAdmin ?? false,
        isLoading,
        isError,
        refetch,
    }
}
